import React from 'react';
import Button from '@material-ui/core/Button';
import confirm from 'utils/confirm';
import {unsavedMessage} from 'utils/const';
import noop from 'lodash/noop';
import Dialog from 'components/pure/utils/Dialog';
import ReasonSchemeFormDialogHelp from 'components/pure/admin/ReasonSchemeFormDialogHelp';
import Loading from 'components/pure/utils/Loading';
import CardReasonSchemeForm from 'components/pure/admin/CardReasonSchemeForm';
import './ScorecardReasonDialog.styl';
import {validate as validateReasons} from 'records/CardReasonSchemeEntry';
import CardReasonActions from 'actions/CardReasonActions';

export const required = ['name'];

export default class CardReasonFormDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onSave = this.onSave.bind(this);
    this.hasError = this.hasError.bind(this);
    this.refreshReasons = this.refreshReasons.bind(this);
    this.deleteScheme = this.deleteScheme.bind(this);
    this.onRequestClose = this.onRequestClose.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = {
      unsavedChanges: false,
    };
  }

  refreshReasons() {
    const {scorecardScheme} = this.props;

    if (scorecardScheme) {
      return CardReasonActions.fetchReasonSchemesForScoringScheme(scorecardScheme);
    } else {
      return CardReasonActions.fetchAll();
    }
  }

  async onSave() {
    const {cardReasonScheme} = this.props.editStore;

    const savedReason = await this.props.editActions.saveCardReasonScheme(cardReasonScheme);

    // refresh all reasons to get our new one in the list
    await this.refreshReasons();

    const {schemeWithNameExists} = this.props.editStore;

    // block the dialog from closing to allow the user to rename.
    // for other errors, we just toast that something bad happened.
    if (schemeWithNameExists) {
      return;
    }

    // callback with new scheme so we can potentially attach to the question!
    this.props.onRequestClose(savedReason);
  }

  onRequestClose() {
    const {unsavedChanges} = this.state;

    if (unsavedChanges) {
      confirm(unsavedMessage).then(this.props.onRequestClose, noop);
    } else {
      this.props.onRequestClose();
    }
  }

  onChange(value) {
    this.setState({unsavedChanges: true});

    this.props.editActions.updateForm(value);
  }

  deleteScheme() {
    const {cardReasonScheme} = this.props.editStore;
    this.props.editActions.deleteCardReasonScheme(cardReasonScheme.id).then(() => {
      this.refreshReasons();
      this.props.onRequestClose();
    });
  }

  hasError() {
    const {cardReasonScheme} = this.props.editStore;
    if (cardReasonScheme === undefined) {
      return;
    }
    const isBlank = value => (value || '').trim() === '';
    return (
      required.some(property => isBlank(cardReasonScheme[property])) ||
      cardReasonScheme.entries.some(validateReasons)
    );
  }

  render() {
    const {cardReasonScheme, isLoading, wasErrorFetching, isSaving, schemeWithNameExists} =
      this.props.editStore;

    // allowChoosingReasonScheme - only allow selecting reason scheme on a create new request.
    const {allowChoosingReasonScheme} = this.props;

    return (
      <Dialog
        title={
          'Preset Reasons Schemes - ' +
          (cardReasonScheme && cardReasonScheme.id ? 'Edit' : 'Create')
        }
        className="scorecard-reason-scheme-form-dialog"
        autoScrollBodyContent={true}
        closeButton={true}
        actions={[
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            onClick={this.onSave}
            disabled={isSaving || isLoading || wasErrorFetching || this.hasError()}>
            Save
          </Button>,
          <Button
            variant="outlined"
            className="cancel-button ev-button"
            onClick={this.onRequestClose}>
            Cancel
          </Button>,
          <Button variant="text" className="delete-link" onClick={this.deleteScheme}>
            Delete Preset Score Reason Scheme
          </Button>,
        ]}
        open={true}
        onRequestClose={this.onRequestClose}>
        <ReasonSchemeFormDialogHelp />
        {wasErrorFetching ? (
          'Error fetching reason scheme.'
        ) : isLoading ? (
          <Loading />
        ) : (
          <CardReasonSchemeForm
            cardReasonScheme={cardReasonScheme}
            schemeWithNameExists={schemeWithNameExists}
            onChange={this.onChange}
            allowChoosingReasonScheme={allowChoosingReasonScheme}
          />
        )}
      </Dialog>
    );
  }
  Car;
}
